module.exports = __webpack_public_path__ + "static/img/bg.708f8f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/bg.jpg
// module id = Yfqv
// module chunks = 191